<template>
  <v-row>
    <v-col cols="">
      <v-card outlined>
        <v-card-title class="d-flex gap-x-2 gap-y-2 align-center">
          <h5>{{ request.Service.name }}</h5>
          <v-chip label :color="serviceStatus[request.status].color" small>
            <v-icon x-small class="pr-1">{{ serviceStatus[request.status].icon }}</v-icon>
            {{ serviceStatus[request.status].text }}
          </v-chip>
          <v-spacer />
          <small>
            <v-icon small> mdi-calendar-end </v-icon>
            {{ request.deadline | date }}
          </small>
        </v-card-title>
        <v-card-text>
          <v-card outlined class="pa-2">
            <p class="font-weight-bold">Descrição</p>
            <p class="mb-0">{{ request.description }}</p>
          </v-card>

          <div class="d-flex flex-wrap gap-x-4 gap-y-1 mt-4 justify-space-around">
            <div>
              <v-icon small left> mdi-account </v-icon>
              <span class="font-weight-bold">Solicitado por:</span>
              {{ request.RequiredBy.name }}
            </div>
            <div>
              <v-icon small left> mdi-account-wrench </v-icon>
              <span class="font-weight-bold">Responsável:</span>
              {{ request.Responsible.name }}
            </div>
            <div>
              <v-icon small left> mdi-calendar </v-icon>
              <span class="font-weight-bold">Solicitado em:</span>
              {{ request.createdAt | date }}
            </div>
            <div v-if="isExport">
              <v-icon small left> mdi-calendar </v-icon>
              <span class="font-weight-bold">Endereço:</span>
              {{ request.Immobile.Address.street }}, {{ request.Immobile.Address.number }} -
              {{ request.Immobile.Address.city }} - {{ request.Immobile.Address.state }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" sm="3" md="3" lg="2" v-if="request.Immobile && !isExport">
      <v-card class="w-full h-full" @click="openMap()">
        <v-img :src="request.Immobile.Address.mapUrl" height="100%" :aspect-ratio="1"> </v-img>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import serviceStatus from '@/utils/serviceStatus'
export default {
  name: 'ServiceHeader',
  data: () => ({
    serviceStatus,
  }),
  methods: {
    openMap() {
      const address = `${this.request.Immobile.Address.street}, ${this.request.Immobile.Address.number} - ${this.request.Immobile.Address.city} - ${this.request.Immobile.Address.state}`
      window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank')
    },
  },
  props: {
    loading: Boolean,
    request: Object,
    isExport: Boolean,
  },
}
</script>
